import { retrieveToken } from '../storage';
import { wrapFetch, apiFetch, apiError, RICHIESTA_NON_VALIDA } from './api';

/**
 * Chiama l'API /api/rollout/status/batch?api-code=...
 * @param {number[]} eserciziCommercialiIds - Array di id esercizi commerciali
 * @param {string} apiCode - Codice API (es: 'GESTIONE_OPERATIVA')
 * @returns {Promise<{apiCode: string, list: Array<{idEsercizio: number, open: boolean}>}>}
 */
export async function getRolloutStatusBatch(eserciziCommercialiIds, apiCode) {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);

  const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

  const PATH = `/api/rollout/status/batch?api-code=${encodeURIComponent(
    apiCode,
  )}`;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify({ eserciziCommercialiIds }),
    }),
    apiError({
      400: RICHIESTA_NON_VALIDA,
    }),
  );
}
